export default {
  blogOperationMode(state) {
    return state.operation;
  },
  blogErrors(state) {
    return state.error;
  },
  blogSuccess(state) {
    return state.success;
  },
  getBlogSelectedInstance(state) {
    return state.blogSelectedInstance;
  },
  getInstanceCreateLoading(state) {
    return state.instanceCreateLoading;
  },
  getInstanceCopyLoading(state) {
    return state.instanceCopyLoading;
  },
  getInstanceEditLoading(state) {
    return state.instanceEditLoading;
  },
  getBlogComponentAttrs(state) {
    return state.blogComponentAttrs;
  },
  getBlogComponentInstances(state) {
    return state.blogComponentInstances;
  },
  getBlogInstancesLoading(state) {
    return state.blogComponentInstancesLoading;
  },
  getBlogComponentLoading(state) {
    return state.blogComponentLoading;
  }
};
